// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const cn = {
  Hi: "你好",
  Description: "需要帮忙？\n 请查看我们的文档。",
  Documentation: "文档",
  EnglishLevel: "英语水平",
  FrenchLevel: "法语水平",
  EnglishExam: "英语考试",
  FrenchExam: "法语考试",
  ExamType: "考试类型",
  Score: "分数",
  ReadingScore: "阅读分数",
  WritingScore: "写作分数",
  ListeningScore: "听力分数",
  SpeakingScore: "口语分数",
  ExamDate: "考试日期",
  Yes: "是的",
  Applicant: "申请人",
  Mother: "母亲",
  Father: "父亲",
  Brothers: "兄弟",
  Sisters: "姐妹",
  Children: "孩子们",
  Education: "教育",
  Relations: "关系",
  Languages: "语言",
  Experience: "经验",
  Activities: "活动",
  Addresses: "地址",
  Travels: "旅行",
  Passports: "护照",
  OtherInformation: "其他",
  DateofDeath: "死亡日期",
  ApplyForVisaCanadaBefore: "您或您的任何家庭成员是否曾申请过加拿大签证？ （旅游、住宅、工作、教育等）？",
  VisaCanadaRejectedBefore: "您或任何家庭成员是否曾被加拿大或其他国家的签证申请拒绝？",
  ReportedExperience: "您或您的任何家庭成员是否曾被加拿大或任何其他国家驱逐出境？",
  ModifiedDate: "修改日期",
  SaveChanges: "保存更改",
  OveralExamScore: "综合考试成绩",
  ExpireDate: "到期日期",
  SelectYourLevel: "选择您的级别",
  DidYouHaveExam: "你有考试吗？",
  WitchExam: "巫师考试？",
  SelectLanguage: "选择语言",
  AsylumApplied: "您或您的任何家庭成员是否曾在加拿大或任何其他国家申请过庇护？",
  ArrestedBefore: "您或您的任何家庭成员是否曾经犯罪或被捕过？",
  HealthCareBefore: "除了服药之外，您或您的任何家庭成员在加拿大期间是否需要医疗保健提供者的帮助？",
  StayLongerThanVisa: "您或您的家人是否有任何在加拿大或其他国家逗留时间超过签证有效期的经历？",
  TerroristHistory: "您或您的任何家庭成员是否有参与政治团体或恐怖组织等的历史",
  SecurityProblems: "请充分说明您或您的任何家庭成员是否有任何渎职、安全问题或以前在加拿大或任何其他国家/地区的签证相关行为的历史。",
  No: "不",
  Expert: "专家",
  VeryGood: "很好",
  Good: "好的",
  Competent: "胜任的",
  Modest: "谦虚的",
  Limited: "有限的",
  None: "没有任何",
  IELTSGeneral: "雅思综合",
  IELTSAcademic: "雅思学术",
  CELPIPG: "CELPIP-G",
  TEF: "TEF",
  CELPIP: "赛尔皮",
  Gender: "性别",
  FirstName: "名",
  LastName: "姓",
  FirstNameNativeLanguage: "名字（母语）",
  LastNameNativeLanguage: "姓氏（母语）",
  FirstNameEnglish: "名字（英文）",
  LastNameEnglish: "姓氏（英文）",
  DateofBirth: "出生日期",
  Height: "高度",
  EyeColor: "眼睛的颜色",
  CityofBirth: "出生城市",
  CountryofBirth: "出生国家",
  DeathDate: "死亡日期",
  CityofDeath: "死亡之城",
  CountryofDeath: "死亡之国",
  PostalCode: "邮政编码",
  JobTitle: "职称",
  Company: "公司",
  Email: "电子邮件",
  MaritalStatus: "婚姻状况",
  ChildNumber: "儿童编号",
  DateofMarriage: "结婚的日期",
  DateofDivorce: "离婚日期",
  Address: "地址",
  NetWorth: "净值",
  EducationLevel: "教育程度",
  EducationMajor: "教育专业",
  MoreAboutEducation: "更多关于教育",
  WorkExperince: "工作经历",
  WorkType: "工作类型",
  MoreAboutWork: "更多关于工作",
  PleaseExplainAboutYourEducationHistory: "请解释您的教育经历",
  PleaseExplainAboutYourJobHistory: "请解释您的工作经历",
  General: "一般的",
  Profile: "轮廓",
  AssessmentForm: "评估表",
  SocialLinks: "社交链接",
  ChangePassword: "更改密码",
  AccountSettings: "帐号设定",
  Account: "帐户",
  ClientsEvaluated: "客户评价",
  ImmigrationCases: "移民案件",
  TotalPosts: "帖子总数",
  About: "关于",
  LiveAt: "住在&nbsp",
  YouAreAssessed: "将评估您的信息",
  AssessingYou: "评估你",
  AssessMe: "评估我",
  HasAccessDocuments: "有权访问您的文件",
  DisconnectAccess: "断开访问",
  DocumentAccess: "文档访问",
  Password: "密码",
  App: "应用程序",
  user: "用户",
  List: "列表",
  Edit: "编辑",
  Shop: "店铺",
  Blog: "博客",
  Mail: "邮件",
  Chat: "聊天",
  Cards: "牌",
  Posts: "帖子",
  Create: "创造",
  Banking: "银行业",
  Booking: "预订",
  Product: "产品",
  Invoice: "发票",
  Details: "细节",
  Checkout: "查看",
  Calendar: "日历",
  Analytics: "分析",
  Ecommerce: "电子商务",
  Management: "帐户管理",
  Menu: "菜单",
  Item_disabled: "项目已禁用",
  Item_label: "物品标签",
  Item_caption: "项目标题",
  Other_cases: "其他案例",
  Item_by_roles: "按角色分类",
  Only_admin_can_see_this_item: "只有管理员可以看到这个项目",
  TotalElementarySchool: "小学总年限",
  TotalMiddleSchool: "中学教育总年限",
  TotalHighSchool: "高中教育总年限",
  TotalPreUniversity: "大学预科教育总年限",
  TotalAssociate: "副学士学位总学年",
  TotalUndergraduate: "本科学习总年限",
  TotalMaster: "硕士学位的总学习年限",
  TotalDoctoral: "博士研究总年限",
  TotalProfessional: "技术和专业学年总数",
  Organization: "组织",
  Degree: "程度",
  Major: "主要的",
  SelectType: "选择类型",
  StartDate: "开始日期",
  EndDate: "结束日期",
  City: "城市",
  Country: "国家",
  Relation: "关系",
  CityofResidence: "居住城市",
  ProvinceofResidence: "居住省",
  ActivityType: "活动类型",
  ActivityLocation: "活动地点",
  License: "执照",
  MoreInformation: "更多信息",
  PassportNumber: "护照号",
  IssueDate: "发行日期",
  ExpiryDate: "到期日",
  DayPerWeek: "每周日",
  HourPerDay: "每天一小时",
  CompanyPhone: "公司电话",
  CEOName: "首席执行官姓名",
  CEOPhoneNumber: "首席执行官电话号码",
  YourManagerName: "您的经理姓名",
  YourManagerTitle: "您的经理头衔",
  YourManagerPhoneNumber: "您的经理电话号码",
  CompanyPostalCode: "公司邮政编码",
  ActivityLocationHelper: "",
  FullTime: "全职",
  PartTime: "兼职",
  Citizen: "公民",
  PermanentResidence: "永久居留",
  TemporaryResidence: "暂住",
  StatusinCanada: "在加拿大的地位",
  Spouse: "伴侣",
  Background: "背景",
  Documents: "文件",
  Questioner: "问卷",
  Personal: "个人的",
  PersonalPhoto: "",
  InformationAboutPersonalPhoto: "个人照片信息",
  UploadFile: "上传文件",
  PrintTime: "打印时间",
  TranslationDateIfTranslated: "翻译日期（如果已翻译）",
  NationalID: "国民身份证",
  MilitaryServiceLicense: "服兵役执照",
  PhotocopyMarriageCertificate: "结婚证/证书复印件",
  IDCard: "身份证",
  PhotocopyDivorceDocuments: "离婚文件复印件",
  NumberofChildren: "儿童数量",
  Consultants: "顾问",
  MyAccount: "我的帐户",
  consultant: "顾问",
  applicant: "申请人",
  ShareWhatThinkingAbout: "分享你的想法",
  Post: "邮政",
  Logout: "登出",
  Home: "家",
  Beta: "贝塔",
  SignUp: "报名",
  Dashboard: "仪表板",
  Pages: "页面",
  Other: "其他",
  AboutUs: "关于我们",
  ContactUs: "联系我们",
  Pricing: "价钱",
  Login: "登录",
  Register: "登记",
  ResetPassword: "重设密码",
  WriteComment: "写个评论…",
  Authentication: "验证",
  SortBy: "排序方式",
  Name: "姓名",
  Applicants: "申请人",
  Immigrationfromhereto: "移民从这里到",
  Canada: "加拿大",
  BetterProbroadimmigrationplatform: "BetterPro 是一个广泛的移民平台，允许移民和顾问找到彼此并保持联系",
  GetStarted: "开始使用",
  HowBetterProHelpYou: "BetterPro 如何帮助您？",
  ServicesForConsultants: "顾问的特殊服务",
  Questionnaire: "问卷",
  CollectInformationAboutClients: "收集有关客户的信息，例如他们的个人信息、工作、教育等，并使用该信息填写移民表格",
  CollectingDocuments: "收集文件",
  GatherDocumentsfromApplicants: "根据每个移民案件的需要，以分类的方式从申请人那里收集文件。",
  SafeCommunication: "安全通讯",
  ConsultantsApplicantsCommunicate: "移民顾问和申请人可以在移民过程的各个阶段（从初步评估到获得签证）通过 BetterPro 进行沟通",
  ProfilePage: "个人资料页",
  HavinguptodateProfiles: "拥有多种语言的最新个人资料将帮助您吸引更多客户",
  PlansCustomized: "可定制的计划",
  ToMeetYourNeeds: "满足贵公司的需求",
  MakeModernOnline: "通过选择计划使您的现代在线业务取得成功",
  PlusTaxes: " * 加上适用的税费",
  mo: "/月",
  POPULAR: "受欢迎的",
  Basic: "基本的",
  ThirtyDaysTrial: "30 天试用 / 无需信用卡",
  SixtyDaysTrial: "60 天试用 / 无需信用卡",
  NinetyDaysTrial: "90 天试用 / 无需信用卡",
  MultilanguageProfile: "多语言简介",
  Blogging: "写博客",
  AccessToLeads: "访问潜在客户",
  ComminicateWithClients: "与客户沟通",
  FullSupport: "全力支持",
  Starter: "起动机",
  Premium: "优质的",
  ChoosePremium: "选择高级",
  ChooseStarter: "选择入门",
  ChooseBasic: "选择基本",
  GetStartedWith: "开始使用",
  BetterProPlatformToday: "今天的 BetterPro 平台",
  WhereFindUs: "在哪里可以找到我们？",
  FeelFreeContactUs: "欢迎与我们联系。",
  WeGladHearFromYou: "我们很高兴收到您的来信。",
  ToShareYourComment: "分享您的评论",
  PleaseSignup: "请注册",
  IAmConsultant: "我是移民顾问/律师",
  IAmImmigrate: "我打算移民加拿大",
  SelectBestOption: "选择最佳选项",
  AlreadyHaveAccount: "已经有一个帐户？",
  BroadImmigrationPlatformBetterPro: "BetterPro 广泛的移民平台",
  GetStartedFree: "完全免费开始。",
  NoCreditNeeded: "不需要信用卡。",
  DontHaveAccount: "没有帐户？",
  EnterDetails: "在下面输入您的详细信息。",
  WelcomeBack: "你好，欢迎回来",
  RememberMe: "记得我",
  ForgotPassword: "忘记密码？",

  FieldofStudy: "Field of Study",
  TypeofWork: "Type of Work",
  AnnulledMarriage: "Annulled Marriage",
  CommonLaw: "Common-Law",
  DivorcedSeparated: "Divorced / Separated",
  LegallySeparated: "Legally Separated",
  Married: "Married",
  NeverMarriedSingle: "Never Married / Single",
  Widowed: "Widowed",
  RegisterSaveInformation: "注册以保存信息并接收顾问消息",
  AssessmentForm: "َAssessment Form",
  UserName: "User Name",
  BlogPosts: "Blog Posts",
  NotProfileLanguage: "Consultant does not have a profile for this language. Please select another language.",
  Services: "Services",
  ContactInfo: "Contact Info (Please let the consultant know how best to contact you)",
  PhoneNumber: "Phone Number",
};

export default cn;
